export const DOWNLOAD_DOCUMENT = "DOWNLOAD_DOCUMENT";

export const DOWNLOAD_DOCUMENT_PENDING = "DOWNLOAD_DOCUMENT_PENDING";

export const DOWNLOAD_DOCUMENT_SUCCESS = "DOWNLOAD_DOCUMENT_SUCCESS";

export const DOWNLOAD_DOCUMENT_ERROR = "DOWNLOAD_DOCUMENT_ERROR";

export const CANCEL_COMPLETED_TRANSACTION_PENDING =
  "CANCEL_COMPLETED_TRANSACTION_PRNDING";

export const CANCEL_COMPLETED_TRANSACTION_SUCCESS =
  "CANCEL_COMPLETED_TRANSACTION_SUCCESS";

export const CANCEL_COMPLETED_TRANSACTION_ERROR =
  "CANCEL_COMPLETED_TRANSACTION_ERROR";

export const REMOVE_OWNER = "REMOVE_OWNER";

export const REMOVE_OWNER_PENDING = "REMOVE_OWNER_PENDING";

export const REMOVE_OWNER_SUCCESS = "REMOVE_OWNER_SUCCESS";

export const REMOVE_OWNER_ERROR = "REMOVE_OWNER_ERROR";

export const PHYSICAL_DELIVERY = "PHYSICAL_DELIVERY";

export const PHYSICAL_DELIVERY_PENDING = "PHYSICAL_DELIVERY_PENDING";

export const PHYSICAL_DELIVERY_SUCCESS = "PHYSICAL_DELIVERY_SUCCESS";

export const PHYSICAL_DELIVERY_ERROR = "PHYSICAL_DELIVERY_ERROR";